export default __webpack_public_path__ + "static/media/mezzanine-floor-structure-500x500.ebdb1d2e.jpg";